
import { useAuth } from "@/contexts/AuthContext";
import { useToast } from "@/hooks/use-toast";
import { useNavigate, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";

interface RequireAuthProps {
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

export const RequireAuth = ({ children, fallback }: RequireAuthProps) => {
  const { session } = useAuth();
  const { toast } = useToast();
  const navigate = useNavigate();
  const location = useLocation();

  if (!session) {
    if (fallback) {
      return <>{fallback}</>;
    }

    return (
      <div className="flex flex-col items-center justify-center p-4 space-y-4 bg-gray-50 rounded-lg border border-gray-200">
        <p className="text-sm text-gray-600">Please sign in to use this feature</p>
        <Button
          variant="outline"
          onClick={() => {
            toast({
              title: "Authentication required",
              description: "Please sign in to access this feature"
            });
            navigate("/auth", { state: { from: location } });
          }}
        >
          Sign In
        </Button>
      </div>
    );
  }

  return <>{children}</>;
};
